/** @type {import('tailwindcss').Config} */
import colors from 'tailwindcss/colors.js';
delete colors['lightBlue'];
delete colors['warmGray'];
delete colors['trueGray'];
delete colors['coolGray'];
delete colors['blueGray'];

import theme from 'tailwindcss/defaultTheme.js';

export default {
	content: [],
	theme: {
		colors: {
			...colors,
			blackAlmost: '#131F1D',
			yello: {
				100: '#fff6bf',
			},
			grey: {
				100: "#F3F3F3",
				300: "#efefef",
				400: "#cdcfcd",
				500: "#525252",
				700: "#1d1d1d",
			},
			primary: {
				200: '#835C9D',
				500: '#94859C',
			},
			secondary: {
				300: "#E3EFFF",
				500: "#70A4E4",
			},

			'admin-white': "#FFF",
			'admin-text': "#131F1D",
			'admin-links': "#835C9D",
			'admin-panel-bg': "#f5f5f5",
			'admin-text-grey': "#9A9A9A",

			'admin-menu': "#111111",
			'admin-menu-bg': "#835C9D",
			'admin-menu-hr': "#E3EFFF",

			'admin-table-border': "#e5eae9",
			'admin-table-highlight': "#f5f5f5",
			'admin-table-bg-header': "#ccc6d1",

			'admin-input-icon': '#6A6A6A',
			'admin-input-text': '#131F1D',
			'admin-input-border': '#cdcfcd',
			'admin-input-bg': '#f5f5f5',

			'admin-input-border-highlight': '#835C9D',
			'admin-input-bg-highlight': '#94859C',

			'admin-input-border-disabled': '#ADADAD',
			'admin-input-bg-disabled': '#e5eae9',
			'admin-input-text-disabled': '#9A9A9A',
		},
		fontFamily: {
			...theme.fontFamily,
			avenir: "Avenir, 'Avenir Next LT Pro', Montserrat, Corbel, 'URW Gothic', source-sans-pro, sans-serif",
			arial: 'Arial, Helvetica, sans-serif',
			century: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
			futura: '"Futura LT", Futura, "Trebuchet MS", Arial, Helvetica, sans-serif',
			helvetica: '"Helvetica Neue", Arial, Helvetica, sans-serif',
			helveticaLight: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Arial, Helvetica, sans-serif',
			geneva: 'Geneva, Tahoma, Verdana, sans-serif',
			georgia: 'Georgia, Palatino, "Palatino Linotype", "Times New Roman", serif',
			goudy: '"Goudy Old Style", Georgia, "Times New Roman", serif',
			palatino: 'Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif',
			tahoma: 'Tahoma, Geneva, Verdana, sans-serif',
			times: 'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
			verdana: 'Verdana, Geneva, Tahoma, sans-serif',
			mono: ['ui-monospace', 'Menlo', 'Consolas', 'monospace'],
		},
		screens: {
			...theme.screens,
			sm: '480px',
			xl: '1440px',
			xxl: '1441px',
			'2xl': '1920px',
			'3xl': '1920px'
		},
		extend: {
			scale: {
				'33': '0.3333',
				'25': '0.25',
				'200': '2.0',
			},
			spacing: {
				'128': '32rem',
			},
			zIndex: {
				'60': '60',
				'70': '70',
				'80': '80',
				'90': '90',
				'100': '100',
			},
			animation:{
				'shake': 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
			},
			keyframes: {
				'shake' : {
					'10%, 90%': {
						transform: 'translateX(-2px)'
					},
					'20%, 80%' : {
						transform: 'translateX(4px)'
					},
					'30%, 50%, 70%': {
						transform: 'translateX(-8px)'
					},
					'40%, 60%': {
						transform: 'translateX(8px)'
					}
				}
			}
		},
		borderRadius: {
			...theme.borderRadius,
			'sm': '0.1875rem',
		}
	},
}
